import {
  MajorModel,
  OccupationQuickMatchModel
} from '@cpd-app/core-module/models';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export const majorFeatureKey = 'major';

export const majorStateAdapter: EntityAdapter<OccupationQuickMatchModel> =
  createEntityAdapter<OccupationQuickMatchModel>({
    selectId: (occupationMicroModel: OccupationQuickMatchModel) =>
      occupationMicroModel.onetCode,
    sortComparer: false
  });

export interface MajorState extends EntityState<OccupationQuickMatchModel> {
  majorModel: MajorModel;
}

export const initialMajorState: MajorState = majorStateAdapter.getInitialState({
  majorModel: null
});

export const { selectAll, selectEntities, selectIds, selectTotal } =
  majorStateAdapter.getSelectors();
